(function () {
  const pendingButtons = new Set();
  const buttonTimeouts = new WeakMap();
  const TIMEOUT_MS = 10000;

  const ADD_TO_CART_BUTTON_SELECTOR =
    'product-form button[name="add"], form[data-type="add-to-cart-form"] button[name="add"], .product-form__submit, .quick-add__submit';

  function isSlideCartActive() {
    return (
      typeof window.SLIDECART_OPEN === 'function' ||
      typeof window.SLIDECART_STATE === 'function' ||
      !!document.getElementById('slidecarthq')
    );
  }

  function isSlideCartOpen() {
    return !!document.querySelector('#slidecarthq .slidecarthq.open');
  }

  function findAddToCartButton(target) {
    if (!(target instanceof Element)) return null;

    const button = target.closest(ADD_TO_CART_BUTTON_SELECTOR);
    if (!button || button.disabled) return null;
    if (button.classList.contains('loading') || pendingButtons.has(button)) return null;

    if (button.closest('product-form') || button.closest('form[data-type="add-to-cart-form"]')) {
      return button;
    }

    return null;
  }

  function ensureSpinner(button) {
    let spinner = button.querySelector('.loading__spinner');
    if (spinner) return spinner;

    spinner = document.createElement('div');
    spinner.className = 'loading__spinner hidden';
    spinner.innerHTML =
      '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';
    button.appendChild(spinner);
    return spinner;
  }

  function showButtonLoading(button) {
    if (!button) return;

    button.classList.add('loading');
    ensureSpinner(button).classList.remove('hidden');
  }

  function hideButtonLoading(button) {
    if (!button) return;

    button.classList.remove('loading');
    button.removeAttribute('aria-disabled');
    button.querySelector('.loading__spinner')?.classList.add('hidden');

    const timeoutId = buttonTimeouts.get(button);
    if (timeoutId) {
      clearTimeout(timeoutId);
      buttonTimeouts.delete(button);
    }

    pendingButtons.delete(button);
  }

  function hideAllPendingButtons() {
    pendingButtons.forEach((button) => hideButtonLoading(button));
    pendingButtons.clear();
  }

  function registerPendingButton(button) {
    if (!button) return;

    pendingButtons.add(button);

    if (!buttonTimeouts.has(button)) {
      buttonTimeouts.set(
        button,
        setTimeout(() => hideButtonLoading(button), TIMEOUT_MS)
      );
    }
  }

  function wrapSlideCartCallback(callbackName, onCallback) {
    const existingCallback = window[callbackName];

    window[callbackName] = function (...args) {
      onCallback(...args);

      if (typeof existingCallback === 'function') {
        return existingCallback.apply(this, args);
      }
    };
  }

  function installSlideCartHooks() {
    wrapSlideCartCallback('SLIDECART_OPENED', hideAllPendingButtons);

    wrapSlideCartCallback('SLIDECART_ADD_TO_CART', () => {
      if (isSlideCartOpen()) hideAllPendingButtons();
    });

    wrapSlideCartCallback('SLIDECART_UPDATED', () => {
      if (pendingButtons.size) {
        window.clearTimeout(window.__addToCartLoadingUpdatedTimeout);
        window.__addToCartLoadingUpdatedTimeout = window.setTimeout(hideAllPendingButtons, 150);
      }
    });
  }

  function observeSlideCartOpen() {
    if (window.__slideCartOpenObserved) return;

    const root = document.getElementById('slidecarthq');
    if (!root) return;

    window.__slideCartOpenObserved = true;

    const observer = new MutationObserver(() => {
      if (isSlideCartOpen() && pendingButtons.size) hideAllPendingButtons();
    });

    observer.observe(root, {
      attributes: true,
      subtree: true,
      attributeFilter: ['class'],
    });
  }

  window.AddToCartLoading = {
    isSlideCartActive,
    show: showButtonLoading,
    hide: hideButtonLoading,
    registerPending: registerPendingButton,
  };

  installSlideCartHooks();

  document.addEventListener('DOMContentLoaded', () => {
    installSlideCartHooks();
    observeSlideCartOpen();
  });

  [500, 1500, 3000].forEach((delay) => {
    setTimeout(() => {
      installSlideCartHooks();
      observeSlideCartOpen();
    }, delay);
  });

  document.addEventListener(
    'click',
    (event) => {
      if (!isSlideCartActive()) return;

      const button = findAddToCartButton(event.target);
      if (!button) return;

      showButtonLoading(button);
      registerPendingButton(button);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      if (!isSlideCartActive()) return;

      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.dataset.type !== 'add-to-cart-form') return;

      const button = form.querySelector('[type="submit"][name="add"]');
      if (!button || button.disabled || button.classList.contains('loading')) return;

      showButtonLoading(button);
      registerPendingButton(button);
    },
    true
  );
})();
